import React, { useContext } from "react";
import { GlobalContext } from "../../../contexts/GlobalContext";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableHeader,
    Badge,
} from "../../../components/ui";

const thClass =
    "px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400";

export function ProductBrandList({ onOpenBrandModal }) {
    const { brands } = useContext(GlobalContext);

    return (
        <div className="space-y-4">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <button
                    type="button"
                    onClick={() => onOpenBrandModal({})}
                    className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-green-700"
                >
                    <i className="fas fa-plus" aria-hidden="true" />
                    Agregar Nueva Marca
                </button>
                <Badge variant="primary" className="w-fit px-3 py-1">
                    <i className="fas fa-list mr-1" aria-hidden="true" />
                    {brands.length} {brands.length === 1 ? "marca" : "marcas"}
                </Badge>
            </div>

            <div className="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
                <Table className="text-sm">
                    <TableHead>
                        <tr>
                            <TableHeader className={`${thClass} w-24 text-center`}>
                                <i className="fas fa-hashtag mr-1" aria-hidden="true" />
                                Código
                            </TableHeader>
                            <TableHeader className={thClass}>
                                <i className="fas fa-tag mr-1" aria-hidden="true" />
                                Nombre
                            </TableHeader>
                            <TableHeader
                                align="center"
                                className={`${thClass} w-28`}
                            >
                                <i className="fas fa-cog mr-1" aria-hidden="true" />
                                Acciones
                            </TableHeader>
                        </tr>
                    </TableHead>
                    <TableBody>
                        {brands.length > 0 ? (
                            brands.map((item, index) => (
                                <TableRow key={index} hover>
                                    <TableCell align="center">
                                        <span className="inline-flex rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-700 dark:bg-gray-700 dark:text-gray-200">
                                            {item.productBrandID}
                                        </span>
                                    </TableCell>
                                    <TableCell className="font-medium">
                                        {item.name}
                                    </TableCell>
                                    <TableCell align="center">
                                        <button
                                            type="button"
                                            onClick={() => onOpenBrandModal(item)}
                                            title="Editar marca"
                                            className="inline-flex items-center rounded-lg border border-blue-600 px-3 py-1 text-sm font-semibold text-blue-600 transition-colors hover:bg-blue-50 dark:border-blue-400 dark:text-blue-400 dark:hover:bg-blue-900/30"
                                        >
                                            <i
                                                className="fas fa-edit mr-1"
                                                aria-hidden="true"
                                            />
                                            Editar
                                        </button>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell
                                    colSpan={3}
                                    align="center"
                                    className="py-10 text-gray-500 dark:text-gray-400"
                                >
                                    <i
                                        className="fas fa-inbox mb-2 text-3xl"
                                        aria-hidden="true"
                                    />
                                    <p className="mb-1 font-medium">
                                        No hay marcas registradas
                                    </p>
                                    <p className="text-xs">
                                        Haga clic en &quot;Agregar Nueva Marca&quot; para
                                        comenzar
                                    </p>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}
